import React from "react";
import DateGeneralInput from "../../input/date-general-input";

const Date1Widget = ({ widget, onValueUpdate }) => {
  const handleValueUpdate = (data) => {
    const updatedWidget = { ...widget, value: data };
    console.log("date updated", data);
    onValueUpdate(updatedWidget);
  };

  return (
    <div className="flex items-stretch h-full w-full">
      {widget && (
        <DateGeneralInput
          valueSpec={widget}
          onChange={handleValueUpdate}
          zIndex="var(--z-index-automation-input)"
        />
      )}
    </div>
  );
};

export default Date1Widget;
